// @flow

import AbstractSort from './abstract/AbstractSort';
import EventNames from '../constants/EventNames';

export default class SortSelect extends AbstractSort {
  /**
   * @inheritDoc
   */
  get event(): string {
    return EventNames.CHANGE;
  }

  /**
   * @inheritDoc
   */
  get value(): string {
    return this.el.value;
  }
}
